import { KaskoService } from '../services/kaskoService';

// actions types

export const FETCH_AUTO_DATA_REQUEST = 'FETCH_AUTO_DATA_REQUEST';
export const FETCH_AUTO_DATA_SUCCESS = 'FETCH_AUTO_DATA_SUCCESS';
export const FETCH_AUTO_DATA_FAILURE = 'FETCH_AUTO_DATA_FAILURE';

// actionCreators

export function fetchAutoDataRequest() {
  return {
    type: FETCH_AUTO_DATA_REQUEST
  }
}

export function fetchAutoDataSuccess(data) {
  return {
    type: FETCH_AUTO_DATA_SUCCESS,
    payload: data
  }
}

export function fetchAutoDataFailure(isError) {
  return {
    type: FETCH_AUTO_DATA_FAILURE,
    payload: isError
  }
}

export function fetchAutoData(autoNumber) {
  const { getAutoDataByNumber } = new KaskoService();

  return function (dispatch) {
    dispatch(fetchAutoDataRequest());
    getAutoDataByNumber(autoNumber)
      .then((response) => {
        dispatch(fetchAutoDataSuccess(response.data));
      })
      .catch((error) => {
        dispatch(fetchAutoDataFailure(true));
      })
  }
}
